/** GAME REMINDERS — how this player wants to hear about the next game.
 *
 *  Three pills (email / text / both), and — only when a text is wanted — the
 *  mobile box and the separate SMS tick, whose wording comes from the server in
 *  the player's own language.
 *
 *  Everything here is OPTIONAL. A player who leaves it alone keeps exactly what
 *  they had: the email reminder, and no mobile number on file.
 */
export const GoalReminderChoice = ({ t, channel, onChannel, mobile, onMobile,
                                     smsOk, onSmsOk, smsText, mobileMasked,
                                     primaryBtn, ghostBtn }) => {
    const wantsSms = channel === 'sms' || channel === 'both';
    const input = 'w-full rounded-lg border border-white/20 bg-black/20 px-3 py-2 text-base';
    return (
        <div className="space-y-2 pt-1" data-testid="goal-reminder-block">
            <p className="text-xs font-semibold opacity-80" data-testid="goal-reminder-title">
                {t('goalGame.reminders.title')}
            </p>
            <div className="flex gap-2">
                {['email', 'sms', 'both'].map((key) => (
                    <button key={key} type="button" onClick={() => onChannel(key)}
                            data-testid={`goal-reminder-${key}`}
                            style={channel === key ? primaryBtn : ghostBtn}
                            className={`flex-1 min-h-[44px] rounded-xl py-2 text-xs font-bold ${
                                channel === key ? '' : 'border border-white/25'}`}>
                        {t(`goalGame.reminders.${key}`)}
                    </button>
                ))}
            </div>
            {wantsSms && (
                <>
                    <input type="tel" value={mobile} inputMode="tel" autoComplete="tel"
                           onChange={(e) => onMobile(e.target.value)} className={input}
                           placeholder={mobileMasked || t('goalGame.reminders.mobilePlaceholder')}
                           data-testid="goal-reminder-mobile" />
                    <label className="flex items-start gap-2 text-[11px] opacity-80">
                        <input type="checkbox" checked={smsOk} data-testid="goal-reminder-sms-consent"
                               onChange={(e) => onSmsOk(e.target.checked)}
                               className="mt-0.5 h-4 w-4 rounded border-white/30" />
                        <span data-testid="goal-reminder-sms-text">{smsText}</span>
                    </label>
                </>
            )}
        </div>
    );
};
